import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router';
import { store } from './store';
import { ThemeProvider } from '@mui/system';
import { theme } from '@/styles/theme';
import { CookiesProvider } from 'react-cookie';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import App from './App';
import * as Sentry from '@sentry/react';

import 'dayjs/locale/pl';
import 'mapbox-gl/dist/mapbox-gl.css';
import './locales/i18n';
import './index.css';

Sentry.init({
  dsn: 'https://ec9738416533a9572eb9b22a43822b6c@o4504458683219968.ingest.us.sentry.io/4509530702807040',
  sendDefaultPii: true,
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <CookiesProvider>
          <ThemeProvider theme={theme}>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pl">
              <App />
            </LocalizationProvider>
          </ThemeProvider>
        </CookiesProvider>
      </BrowserRouter>
    </Provider>
  </StrictMode>
);
